import React from 'react';
import { faShieldCheck } from '@fortawesome/pro-regular-svg-icons/faShieldCheck';
import { Box, Container, Heading, Icon, PageContent, Text } from 'bumbag';
import { useLocation } from 'react-router-dom';

function Success() {
  const location = useLocation();
  //////////////////////////////////////////
  // @ts-expect-error
  const businessName = location?.state?.businessName;
  //////////////////////////////////////////
  return (
    <Container isFluid>
      <PageContent
        alignX="center"
        maxWidth="400px"
        wrapperProps={{
          backgroundColor: 'white600',
          border: 'none',
        }}
      >
        {/* @ts-expect-error TS(2322): Type 'IconDefinition' is not assignable to type 's... Remove this comment to see the full error message */}
        <Icon icon={faShieldCheck} type="font-awesome" fontSize="200px" marginRight="major-1" color="primary" />
        <Box marginTop="major-2">
          <Text fontSize="1.4rem">Your details have been saved with</Text>
          <Heading use="h4" alignX="center">
            {businessName}
          </Heading>
        </Box>
      </PageContent>
    </Container>
  );
}

export default Success;
